module.exports = __webpack_public_path__ + "static/img/7.00d91b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/7.png
// module id = zzyJ
// module chunks = 56